module.exports = __webpack_public_path__ + "img/lock.933d6edc.svg";